import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getBaseUrl } from '../utils/api';

const baseQuery = fetchBaseQuery({
  baseUrl: getBaseUrl(),
  credentials: 'include',
});

// Root API Slice
export const apiSlice = createApi({
  baseQuery: baseQuery,
  endpoints: () => ({}),
});

export default apiSlice;
